<template>
  <div v-scroll:reveal="{ delay: 100 }" class="page-header__breadcrumbs">
    <RouterLink to="/">Accueil</RouterLink>
    <span>/</span>

    <template v-for="node in breadcrumbNodes">
      <RouterLink :key="node" :to="{ name: node }">
        {{ labels[node] }}
      </RouterLink>

      <span :key="`${node}-slash`">/</span>
    </template>
  </div>
</template>

<script>
export default {
  name: 'BreadCrumbs',
  data() {
    return {
      labels: {
        about: 'À propos',
        'about-members': 'Membres',
        events: 'Événements',
        'event-index': 'Nos Événements',
        'project-index': 'Projets',
        'publication-index': 'Publications',
        'news-index': 'Nouvelles',
        'resources-index': 'Outils',
        'resources-monitoring': 'Veille informationnelle'
      }
    }
  },
  computed: {
    breadcrumbNodes() {
      return this.$route.meta.parents || []
    }
  }
}
</script>
